import { render, staticRenderFns } from "./Liquidations.vue?vue&type=template&id=15392301&"
import script from "./Liquidations.vue?vue&type=script&lang=js&"
export * from "./Liquidations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports